
export default () => ({
  isLoading: true,
  serviceLoaded: false,
  info: {
    id: null,
    name: null,
    rating: null,
    category: 0,
    country: {
      slug: null,
      name: null
    },
    city: {
      id: null,
      name: null
    },
    photos: {
      headImage: null,
      images: [],
      total: 0
    },
    description: {
      short: null,
      full: null
    },
    facts: {
      main: [],
      secondary: []
    }
  },
  accommodations: {
    isLoading: true,
    hasError: false,
    searchId: null,
    current: {
      id: null,
      meals: {
        mapped: null,
        supplier: null
      },
      tourists: [],
      room: [],
      price: {
        amount: 0,
        markup: 0,
        currency: 'RUB'
      }
    },
    collection: [],
    errors: []
  },
  tariffConditions: {
    isLoading: true,
    hasError: false,
    additionalInfo: null,
    remarks: [],
    importantInfo: [],
    errors: []
  },
  penalties: {
    isLoading: true,
    hasError: false,
    collection: [],
    errors: []
  },
  form: {
    placeId: null,
    checkInDate: null,
    duration: null,
    rooms: [],
    currency: null,
    isRepeatedSearch: 0,
    priceSort: 'ascending',
    isNotPenalty: 0,
    meals: []
  },
  filters: {
    meals: [],
  },
  collectionFilters: {
    meals: []
  },
})